var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import { Box, FormLabel, Grid, TextField, Typography } from '@mui/material';
import { format, add, isBefore } from 'date-fns';
import { useRequest } from '../../../hooks/requestHook';
import { useNotify } from '../../../hooks/notificationHook';
import { useConfirm } from '../../../hooks/confirmationHook';
import { useDeliveryRequestListItem } from '../../../hooks/useListItem';
import useFormikTextField from '../../../hooks/hoc/useFormikTextField';
import { deliveryRequest as api } from '../../../api';
import { camelize } from '../../../utils/camelize';
import PageSubmitButton from '../../molecules/PageSubmitButton';
import { FormikSelectField } from '../../atoms/SelectField';
import { FormikTextField } from '../../atoms/TextField';
import FormikSelectCountryCallingCodeField from '../../atoms/FormikSelectCountryCallingCodeField';
import FormikDatePicker from '../../atoms/FormikDatePicker';
import CurrencyTextField from '../../organisms/CurrencyTextField';
import { DeliveryRequestFieldFormats } from '../../../constants/fieldFormats';
import { DatePicker } from '@mui/x-date-pickers';
var REQUIRED_FIELDS = [
    'person_name',
    'postal_code',
    'prefecture',
    'city',
    'address',
    'phone',
    'country_calling_code',
    'status',
];
var REQUIRED_FIELDS_AFTER_SHIPPED = [
    'delivery_company',
    'tracking_url',
];
var toFormValues = function (deliveryRequest, warehouse) {
    var deliveryCompany = deliveryRequest.status === 'requested' &&
        !deliveryRequest.deliveryCompany.trim()
        ? warehouse.defaultDeliveryCompany
        : deliveryRequest.deliveryCompany;
    var trackingUrl = deliveryRequest.status === 'requested' &&
        !deliveryRequest.trackingUrl.trim()
        ? warehouse.defaultTrackingUrl
        : deliveryRequest.trackingUrl;
    return {
        store_name: deliveryRequest.storeName,
        person_name: deliveryRequest.personName,
        name_kana: deliveryRequest.nameKana,
        postal_code: deliveryRequest.postalCode,
        prefecture: deliveryRequest.prefecture,
        city: deliveryRequest.city,
        address: deliveryRequest.address,
        building: deliveryRequest.building,
        phone: deliveryRequest.phone,
        country_calling_code: deliveryRequest.countryCallingCode,
        vat_number: deliveryRequest.vatNumber || '',
        eori_number: deliveryRequest.eoriNumber || '',
        status: deliveryRequest.status,
        note: deliveryRequest.note,
        delivered_date: deliveryRequest.deliveredDate,
        delivery_fee: deliveryRequest.deliveryFee,
        discount: deliveryRequest.discount,
        delivery_company: deliveryCompany,
        tracking_url: trackingUrl,
        tracking_number: deliveryRequest.trackingNumber,
        request_date: deliveryRequest.requestDate
            ? new Date(deliveryRequest.requestDate)
            : null,
    };
};
var GridContainer = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.MuiGrid-container {\n    width: 100%;\n    margin: 20px 0px;\n  }\n"], ["\n  &.MuiGrid-container {\n    width: 100%;\n    margin: 20px 0px;\n  }\n"])));
var DeliveryRequestForm = function (_a) {
    var deliveryRequest = _a.deliveryRequest, onDeliveryRequestChanged = _a.onDeliveryRequestChanged;
    var t = useTranslation().t;
    var notify = useNotify();
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var statusItems = useDeliveryRequestListItem().statusItems;
    var confirm = useConfirm();
    var update = useRequest(api.update);
    var navigate = useNavigate();
    var editable = React.useMemo(function () { return deliveryRequest.status !== 'canceled'; }, [deliveryRequest.status]);
    var asyncUpdate = React.useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, update({
                            id: deliveryRequest.id,
                            delivery_request: __assign(__assign({}, values), { request_date: values.request_date
                                    ? format(values.request_date, 'yyyy-MM-dd')
                                    : null }),
                        })];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        return [2 /*return*/, false];
                    onDeliveryRequestChanged(response);
                    notify('success', [t('messages.updateSuccess')]);
                    return [2 /*return*/, true];
            }
        });
    }); }, [
        setLoading,
        update,
        notify,
        t,
        deliveryRequest.id,
        onDeliveryRequestChanged,
    ]);
    var onSubmit = React.useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (values.status === 'canceled') {
                        confirm(t('confirmTitle'), t('messages.cancelConfirm'), function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, asyncUpdate(values)];
                                    case 1:
                                        _a.sent();
                                        navigate('/admin/delivery_requests');
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, asyncUpdate(values)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [t, asyncUpdate, confirm, navigate]);
    var validate = React.useCallback(function (values) {
        var errors = {};
        REQUIRED_FIELDS.forEach(function (field) {
            if (!values[field] || values[field] === '') {
                errors[field] = t('errors.isRequired', {
                    field: t("params.deliveryRequest.".concat(camelize(field))),
                });
            }
        });
        Object.entries(DeliveryRequestFieldFormats).forEach(function (_a) {
            var field = _a[0], regExp = _a[1];
            var fieldAsKey = field;
            var value = values[fieldAsKey];
            if (value && typeof value === 'string' && !regExp.test(value)) {
                errors[fieldAsKey] = t('errors.invalid', {
                    field: t("params.order.".concat(camelize(field))),
                });
            }
        });
        if (values.status === 'delivered' && !values.delivered_date) {
            errors.delivered_date = t('errors.isRequired', {
                field: t('params.deliveryRequest.deliveredDate'),
            });
        }
        if (values.status === 'delivered' && !values.delivery_fee) {
            errors.delivery_fee = t('errors.isRequired', {
                field: t('params.deliveryRequest.deliveryFee'),
            });
        }
        if (['shipped', 'delivered'].includes(values.status)) {
            REQUIRED_FIELDS_AFTER_SHIPPED.forEach(function (field) {
                if (values[field].trim().length === 0) {
                    errors[field] = t('errors.isRequired', {
                        field: t("params.".concat(camelize(field))),
                    });
                }
            });
        }
        return errors;
    }, [t]);
    var warehouse = React.useMemo(function () {
        var _a, _b;
        return ((_b = (_a = deliveryRequest.items[0]) === null || _a === void 0 ? void 0 : _a.warehouseItem) === null || _b === void 0 ? void 0 : _b.warehouse) || {
            defaultDeliveryCompany: '',
            defaultTrackingUrl: '',
        };
    }, [deliveryRequest.items]);
    var formik = useFormik({
        initialValues: toFormValues(deliveryRequest, warehouse),
        onSubmit: onSubmit,
        validateOnMount: true,
        validateOnChange: true,
        validateOnBlur: true,
        validate: validate,
        enableReinitialize: true,
    });
    var handleChangeStatus = React.useCallback(function (event) {
        var value = event.target.value;
        if (value === 'delivered' && !formik.values.delivered_date) {
            setTimeout(function () {
                formik.setFieldValue('delivered_date', format(new Date(), 'yyyy-MM-dd'));
            });
        }
        formik.handleChange(event);
    }, [formik]);
    var FormikCurrencyTextField = useFormikTextField(CurrencyTextField);
    return (React.createElement("form", { onSubmit: formik.handleSubmit },
        React.createElement(GridContainer, { container: true, spacing: 1 },
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikSelectField, { fullWidth: true, label: t('params.deliveryRequest.status'), name: "status", items: statusItems, required: true, onChange: handleChangeStatus, disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 }),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 }, formik.values.status === 'delivered' && (React.createElement(FormikDatePicker, { fullWidth: true, label: t('params.deliveryRequest.deliveredDate'), name: "delivered_date", required: true, disabled: !editable, formik: formik }))),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 }, formik.values.status === 'delivered' && (React.createElement(FormikCurrencyTextField, { fullWidth: true, label: t('params.deliveryRequest.deliveryFee'), name: "delivery_fee", required: true, disabled: !editable, formik: formik, currency: deliveryRequest.currency }))),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 }, formik.values.status === 'delivered' &&
                deliveryRequest.isCampaignTarget && (React.createElement(FormikCurrencyTextField, { fullWidth: true, label: t('params.deliveryRequest.discount'), name: "discount", disabled: !editable, formik: formik, currency: deliveryRequest.currency }))),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(FormikTextField, { fullWidth: true, label: t('params.deliveryCompany'), name: "delivery_company", required: true, disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(FormikTextField, { fullWidth: true, label: t('params.trackingNumber'), name: "tracking_number", disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, label: t('params.trackingUrl'), name: "tracking_url", required: true, disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "store_name", label: t('params.deliveryRequest.storeName'), disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "person_name", label: t('params.deliveryRequest.personName'), disabled: !editable, required: true, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "name_kana", label: t("params.deliveryRequest.nameKana"), disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(FormikTextField, { fullWidth: true, name: "postal_code", inputProps: { maxLength: 9 }, label: t('params.deliveryRequest.postalCode'), required: true, disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(FormikTextField, { fullWidth: true, name: "prefecture", label: t("params.deliveryRequest.prefecture"), required: true, disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(FormikTextField, { fullWidth: true, name: "city", label: t("params.deliveryRequest.city"), required: true, disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(FormikTextField, { fullWidth: true, name: "address", label: t("params.deliveryRequest.address"), required: true, disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "building", label: t('params.deliveryRequest.building'), disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 2 },
                React.createElement(FormikSelectCountryCallingCodeField, { name: "country_calling_code", label: t('params.deliveryRequest.countryCallingCode'), required: true, disabled: !editable, formik: formik })),
            React.createElement(Grid, { item: true, xs: 12, sm: 4 },
                React.createElement(FormikTextField, { fullWidth: true, name: "phone", label: t('params.deliveryRequest.phone'), required: true, disabled: !editable, formik: formik })),
            deliveryRequest.roaster.isOfficeEurope && (React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(FormikTextField, { fullWidth: true, name: "vat_number", label: t('params.deliveryRequest.vatNumber'), disabled: !editable, formik: formik }))),
            deliveryRequest.roaster.country.eoriNumberEnabled && (React.createElement(Grid, { item: true, xs: 12, sm: 4 },
                React.createElement(FormikTextField, { fullWidth: true, name: "eori_number", label: t('params.eoriNumber'), disabled: !editable, formik: formik }))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(RequestDatePicker, { value: formik.values.request_date, deliveryRequest: deliveryRequest, onChange: function (requestDate) {
                        return formik.setFieldValue('request_date', requestDate);
                    } })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(FormikTextField, { fullWidth: true, multiline: true, rows: 3, name: "note", label: t('params.deliveryRequest.note'), disabled: !editable, formik: formik })),
            editable && (React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(PageSubmitButton, { disabled: loading || !formik.isValid }, t('buttons.update')))))));
};
export default DeliveryRequestForm;
var RequestDatePicker = function (_a) {
    var deliveryRequest = _a.deliveryRequest, value = _a.value, onChange = _a.onChange;
    var t = useTranslation().t;
    var minDate = React.useMemo(function () {
        var marginDays = deliveryRequest.roaster.isOfficeEurope ? 14 : 7;
        return add(new Date(), { days: marginDays + 1 });
    }, [deliveryRequest]);
    var maxDate = React.useMemo(function () {
        var date = add(new Date(deliveryRequest.createdAt), {
            months: 10,
            days: 1,
        });
        return isBefore(date, minDate) ? minDate : date;
    }, [deliveryRequest.createdAt, minDate]);
    var changeDate = React.useCallback(function (value) {
        if (value instanceof Date) {
            onChange(value);
            return;
        }
        onChange(null);
    }, [onChange]);
    return (React.createElement(React.Fragment, null,
        React.createElement(FormLabel, { component: "legend" }, t('params.deliveryRequest.requestDate')),
        React.createElement(Typography, { variant: "caption" }, t('pages.deliveryRequestItemsAndRequestDateForm.captions.datePicker.fastestDelivery')),
        React.createElement(Box, null,
            React.createElement(DatePicker, { onChange: changeDate, inputFormat: "yyyy-MM-dd", value: value, minDate: new Date(), maxDate: maxDate, renderInput: function (inputProps) { return (React.createElement(TextField, __assign({}, inputProps, { variant: "outlined", margin: "normal" }))); } }))));
};
var templateObject_1;
